import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type PersonnelProfileWriteOptions = {
    actorId?: string;
};

const PERSONNEL_PUBLIC_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'people_casting',
    capability: 'EDIT_CAST',
    conflictPrefix: 'personnelPublic',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve public personnel profile writes',
};

export async function deletePersonnelProfile(
    scope: ProjectScope,
    personnelId: string,
    options: PersonnelProfileWriteOptions = {}
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: PERSONNEL_PUBLIC_WRITE_REGISTRATION,
        entityId: personnelId,
        kind: 'deleteEntity',
        payload: { id: personnelId },
        actorId: options.actorId,
    });
}
